import { Component, Input, OnInit } from '@angular/core';
import { MatCheckboxChange, MatDialog } from '@angular/material';
import * as _ from 'lodash';
import { CustomPattern } from 'src/app-core/pattern/custom-pattern';
import { CommonDataModel } from '../common-data-model';
import { PdfDialogComponent } from '../pdf-dialog/pdf-dialog.component';

@Component({
    selector: 'app-email-generation-form',
    templateUrl: './email-generation-form.component.html',
    styleUrls: ['./email-generation-form.component.scss']
})
export class EmailGenerationFormComponent implements OnInit {

    commonDataModel = new CommonDataModel();
    emailForm = this.commonDataModel.emailFormModel;
    tempEmailForm = _.cloneDeep(this.commonDataModel.emailFormModel);
    customPattern = new CustomPattern();
    regex: RegExp = new RegExp(this.customPattern.email);
    toFromContact: any;
    toToContact: any;
    toPayerContact: any;
    toIntermediaryContact: any;
    ccFromContact: any;
    ccToContact: any;
    ccPayerContact: any;
    ccIntermediaryContact: any;
    documentConfigData: any;
    toMyself: boolean = false;
    isBol: boolean = true;
    isFvBol: boolean = false;
    src = 'https://vadimdez.github.io/ng2-pdf-viewer/assets/pdf-test.pdf';

    // tempraray data
    shipperContacts = 'shippersontacts@bc.com';
    consigneeContacts = 'consigneesontacts@bc.com';
    payerContacts = 'payercontacts@bc.com';
    integrmediaryContacts = 'integrmediarycontacts@bc.com';

    @Input() orderDetails: any;
    @Input() isReadOnly: any;
    @Input() parentForm: any;
    @Input() fvBolUrl: any;
    @Input() isFv: boolean;
    @Input() isFvBolUrl: boolean;
    @Input() set documentConfigs(documentConfigs: any) {
        if (documentConfigs) {
            this.documentConfigData = documentConfigs;
            this.setInitialConfig();
        }
    }

    constructor(
        private dialog: MatDialog) {
    }

    ngOnInit() {
    }

    setInitialConfig() {
        if (this.documentConfigData) {
            // this.emailForm.to = this.documentConfigData.shipFromEmail ? this.documentConfigData.shipFromEmail : (this.documentConfigData.shipToEmail ? this.documentConfigData.shipToEmail :
            //   (this.documentConfigData.payerEmail ? this.documentConfigData.payerEmail : (this.documentConfigData.intermediateEmail ? this.documentConfigData.intermediateEmail : '')));
            this.emailForm.subject = this.documentConfigData.subject;
            this.emailForm.body = this.documentConfigData.body;
        }
    }

    isEmailtoValid(): boolean {
        return this.validateEmailIds(this.emailForm.to);
    }

    isEmailccValid(): boolean {
        return this.validateEmailIds(this.emailForm.cc);
    }

    isEmailbccValid(): boolean {
        return this.validateEmailIds(this.emailForm.bcc);
    }

    constructCCEmail(): string {
        let ccEmai = '';
        if (this.ccFromContact) {
            ccEmai += this.shipperContacts + ';';
        }
        if (this.ccToContact) {
            ccEmai += this.consigneeContacts + ';';
        }
        if (this.ccPayerContact) {
            ccEmai += this.payerContacts + ';';
        }
        if (this.ccIntermediaryContact) {
            ccEmai += this.integrmediaryContacts + ';';
        }
        return ccEmai;
    }

    validateEmailIds(emails: string): boolean {
        if (emails) {
            const listOfEmails = emails.split(';').map(item => item.trim());
            const isNotvalid = listOfEmails.find(item => !item.match(this.regex));
            if (!isNotvalid) {
                return true;
            }
            return false;
        }
        return true;
    }

    resetForm() {
        this.emailForm = Object.assign({}, this.tempEmailForm);
        this.toFromContact = false;
        this.toToContact = false;
        this.toPayerContact = false;
        this.toIntermediaryContact = false;
        this.ccFromContact = false;
        this.ccToContact = false;
        this.ccPayerContact = false;
        this.ccIntermediaryContact = false;
        this.toMyself = false;
        this.setInitialConfig();
    }

    onChangeFreightViewBol(event: MatCheckboxChange): void {
        if (event.checked) {
            this.dialog.open(PdfDialogComponent, {
                panelClass: 'document_bill_center_layout',
                hasBackdrop: false,
                data: this.fvBolUrl,
                autoFocus: false
            });
        }
    }

}
